"use strict";

function qs(query, root = document) {
  return root.querySelector(query);
}

function qsAll(query, root = document) {
  return root.querySelectorAll(query);
}

window.onload = () => qs('body').classList.add('page-loaded');

document.addEventListener("DOMContentLoaded", function (event) {

  window.harbor = {};

  window.harbor.form = ({

    init: function () {

      const _th = this,
        inputs = qsAll('.form__field-input, .form__field-textarea'),
        forms = qsAll('form'),
        digitsInput = qsAll('.js-digits, .count__input'),
        filedPhone = qsAll('.js-phone');

      function emptyCheck(event) {
        event.target.value.trim() === '' ?
          event.target.classList.remove('not-empty') :
          event.target.classList.add('not-empty')
      }

      if (filedPhone.length){
        for (let phone of filedPhone) {
          $(phone).mask('(999) 999-99-99');
        }
      }

      for (let item of inputs) {
        item.addEventListener('keyup', emptyCheck)
        item.addEventListener('blur', emptyCheck)
      }

      for (let form of forms) {
        form.addEventListener('submit', (e) => {
          return !_th.checkForm(form) && e.preventDefault()
        })
      }

      for (let digitInput of digitsInput) {
        digitInput.addEventListener('keydown', (e) => {
          let validArr = [46, 8, 9, 27, 13, 110, 190]
          if (validArr.indexOf(e.keyCode) !== -1 ||
            (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
            (e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
            (e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            return;
          }
          if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault()
          }
        });
      }

      return this
    },

    checkForm: function (form) {
      let checkResult = true;
      const warningElems = form.querySelectorAll('.error');

      if (warningElems.length) {
        for (let warningElem of warningElems) {
          warningElem.classList.remove('error')
        }
      }

      for (let elem of form.querySelectorAll('input, textarea, select')) {
        if (elem.getAttribute('data-req')) {
          switch (elem.getAttribute('data-type')) {
            case 'tel':
              var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
              if (!re.test(elem.value)) {
                elem.parentNode.classList.add('error')
                checkResult = false
              }
              break;
            case 'email':
              var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
              if (!re.test(elem.value)) {
                elem.parentNode.classList.add('error')
                checkResult = false
              }
              break;
            case 'file':
              if (elem.value.trim() === '') {
                elem.parentNode.classList.add('error')
                checkResult = false
              }
              break;
            default:
              if (elem.value.trim() === '') {
                elem.parentNode.classList.add('error')
                checkResult = false
              }
              break;
          }
        }
      }

      for (let item of form.querySelectorAll('input[data-req^=agreement]')) {
        if (!item.checked) {
          item.classList.add('error')
          checkResult = false
        }
      }

      return checkResult
    }

  }).init()

  window.harbor.obj = {

    map: function () {

      let map = qs('.js-map'),
          coords = map.getAttribute('data-coords').split(',');

      ymaps.ready(function () {

          var myMap = new ymaps.Map("yaMap", {
              center: [coords[0], coords[1]],
              zoom: map.getAttribute('data-zoom') || 14,
              controls: ['largeMapDefaultSet']
          });

          myMap.controls.add('zoomControl', {
              size: 'small'
          });

          myMap.behaviors.disable('scrollZoom');

          let myPlacemark = new ymaps.Placemark(coords, {}, {
              iconLayout: 'default#image',
              iconImageHref: '/static/img/pin.png',
              iconImageSize: [70, 87]
          });

          myMap.geoObjects.add(myPlacemark);

      });

      return;

    },

    count: function () {
      var btnPlus = $('.js-count-plus'),
        btnMinus = $('.js-count-minus');

        btnPlus.on('click', function() {
          var _t = $(this),
            input = _t.siblings('input');
          input.val(parseInt(input.val().trim()) + 1);
          if (parseInt(input.val().trim()) !== 0) {
            _t.siblings('.js-count-minus').attr("disabled", false);
          }
          return false;
        });

        btnMinus.on('click', function() {
          var _t = $(this),
            input = _t.siblings('input');
          if (!_t.attr('disabled') && parseInt(input.val().trim()) !== 0) {
            input.val(parseInt(input.val().trim()) - 1);
            if (parseInt(input.val().trim()) === 0) {
              _t.attr("disabled", true);
            }
          }
          return false;
        });
    },

    mfp: function mfp() {
      let closeMfp = qsAll('.js-close-mfp');
      $('.js-mfp').magnificPopup({
        type: 'inline',
        mainClass: 'mfp-fade'
      });
      if (closeMfp.length) {
        for (let closeMfpItem of closeMfp) {
          closeMfpItem.addEventListener('click', (e) => {
            $.magnificPopup.close();
            e.preventDefault();
          });
        }
      }
    },

    burger: function burger() {
      $('.js-burger').on('click', function() {
        var _t = $(this);
        _t.toggleClass('active');
        _t.siblings('.nav').slideToggle(350);
        $('body').toggleClass('menu-open');
        return false;
      });

      $('.js-toggle-mobile-sublist').on('click', function() {
        var _t = $(this);
        _t.toggleClass('active');
        _t.siblings('.nav__sublist').slideToggle(350);
        return false;
      });
    },

    theme: function theme() {

      var par = $('.js-theme'),
        chThColors = par.find('.radio--color .radio__input'),
        chThHeaderOpacity = par.find('.radio--opacity .radio__input'),
        chThHeaderView = par.find('.radio--view .radio__input');

      // цвет темы
      chThColors.on('change', function() {
        var _t = $(this),
          _tDataColor = _t.data('theme-color');
        $('html').attr('theme-color', _tDataColor);
      });

      // прозрачность шапки
      chThHeaderOpacity.on('change', function() {
        var _t = $(this),
          _tDataColor = _t.data('theme-opacity-header'),
          header = $('.header');
          if ($('.header').data('header-ghost') !== undefined) {
            if (_tDataColor) {
              if (!header.hasClass('header--ghost')) header.addClass('header--ghost');
            } else {
              if (header.hasClass('header--ghost')) header.removeClass('header--ghost')
            }
          }
      });

      // вид шапки
      chThHeaderView.on('change', function() {
        var _t = $(this),
          _tDataColor = _t.data('theme-view-header'),
          header = $('.header');
          if (_tDataColor === 'color') {
            if (!header.hasClass('header--color')) header.addClass('header--color');
          } else {
            if (header.hasClass('header--color')) header.removeClass('header--color')
          }
      });

    },

    init: function init() {

      const _self = this;

      if ($('.js-theme').length) this.theme();

      if ($('.js-count-plus').length && $('.js-count-minus').length) this.count();

      if ($('.js-map').length) this.map();

      if ($('.js-burger').length) this.burger();

      if ($('.js-mfp').length) this.mfp();

      if ($(".js-lightgallery").length) {
        $(".js-lightgallery").lightGallery({
            selector: 'a',
            share: false,
            actualSize: false,
            autoplayControls: false,
            download: false,
            fullScreen: false,
        });
      }

      if ($('.js-datepicker').length) {
        $('.js-datepicker').datepicker({
          autoClose: true,
        });
      }

      if (qs('.js-ihead-swiper')) {
        let iheadSwiper = new Swiper('.js-ihead-swiper', {
          spaceBetween: 0,
          resistance : true,
          resistanceRatio : 0,
          //allowTouchMove: false,
          speed: 700,
          autoplay: {
            delay: 5000,
          },
          navigation: {
            nextEl: '.ihead-slider .swiper-button-next',
            prevEl: '.ihead-slider .swiper-button-prev',
          },
          pagination: {
            el: '.ihead-slider .swiper-pagination',
            type: 'custom',
            renderCustom: function (swiper, current, total) {
              function numberAppend(d) {
                return (d < 10) ? '0' + d.toString() : d.toString();
              }
              return '<span class="swiper-pagination-current">' + numberAppend(current) + '</span>' +
                      ' / ' +
                      '<span class="swiper-pagination-total">' + numberAppend(total) + '</span>';
            },
          },
        });
      }

      if (qs('.js-numbers-swiper')) {
        let numbersSwiper = new Swiper('.js-numbers-swiper', {
          spaceBetween: 32,
          resistance : true,
          resistanceRatio : 0,
          allowTouchMove: false,
          speed: 700,
          navigation: {
            nextEl: '.numbers .swiper-button-next',
            prevEl: '.numbers .swiper-button-prev',
          },
          pagination: {
            el: '.numbers .swiper-pagination',
            type: 'custom',
            renderCustom: function (swiper, current, total) {
              function numberAppend(d) {
                return (d < 10) ? '0' + d.toString() : d.toString();
              }
              return '<span class="swiper-pagination-current">' + numberAppend(current) + '</span>' +
                      ' / ' +
                      '<span class="swiper-pagination-total">' + numberAppend(total) + '</span>';
            },
          },
          breakpoints: {
            992: {
              allowTouchMove: true,
            },
          }
        });
      }

      if (qs('.js-gallery-swiper')) {
        let numbersSwiper = new Swiper('.js-gallery-swiper', {
          resistance : true,
          resistanceRatio : 0,
          //allowTouchMove: false,
          speed: 700,
          navigation: {
            nextEl: '.gallery-slider .swiper-button-next',
            prevEl: '.gallery-slider .swiper-button-prev',
          },
          pagination: {
            el: '.gallery-slider .swiper-pagination',
            type: 'custom',
            renderCustom: function (swiper, current, total) {
              function numberAppend(d) {
                return (d < 10) ? '0' + d.toString() : d.toString();
              }
              return '<span class="swiper-pagination-current">' + numberAppend(current) + '</span>' +
                      ' / ' +
                      '<span class="swiper-pagination-total">' + numberAppend(total) + '</span>';
            },
          },
        });
      }

      if (qs('.js-services-swiper')) {
        let numbersSwiper = new Swiper('.js-services-swiper', {
          spaceBetween: 32,
          resistance : true,
          resistanceRatio : 0,
          //allowTouchMove: false,
          speed: 700,
          navigation: {
            nextEl: '.services .swiper-button-next',
            prevEl: '.services .swiper-button-prev',
          },
          pagination: {
            el: '.services .swiper-pagination',
            type: 'custom',
            renderCustom: function (swiper, current, total) {
              function numberAppend(d) {
                return (d < 10) ? '0' + d.toString() : d.toString();
              }
              return '<span class="swiper-pagination-current">' + numberAppend(current) + '</span>' +
                      ' / ' +
                      '<span class="swiper-pagination-total">' + numberAppend(total) + '</span>';
            },
          },
          breakpoints: {
            320: {
              allowTouchMove: false,
            },
            768: {
              allowTouchMove: true,
            },
          }
        });
      }

      if (qs('.js-about-swiper')) {
        let numbersSwiper = new Swiper('.js-about-swiper', {
          resistance : true,
          resistanceRatio : 0,
          //allowTouchMove: false,
          speed: 700,
          navigation: {
            nextEl: '.about .swiper-button-next',
            prevEl: '.about .swiper-button-prev',
          },
          pagination: {
            el: '.about .swiper-pagination',
            type: 'custom',
            renderCustom: function (swiper, current, total) {
              function numberAppend(d) {
                return (d < 10) ? '0' + d.toString() : d.toString();
              }
              return '<span class="swiper-pagination-current">' + numberAppend(current) + '</span>' +
                      ' / ' +
                      '<span class="swiper-pagination-total">' + numberAppend(total) + '</span>';
            },
          },
        });
      }

      if (qs('.js-reviews-swiper')) {
        let numbersSwiper = new Swiper('.js-reviews-swiper', {
          slidesPerView: 3,
          spaceBetween: 32,
          resistance : true,
          resistanceRatio : 0,
          //allowTouchMove: false,
          speed: 700,
          navigation: {
            nextEl: '.reviews .swiper-button-next',
            prevEl: '.reviews .swiper-button-prev',
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            },
          }
        });
      }

      if ($('.js-toggle-filter').length) {
        $('.js-toggle-filter').on('click', function() {
          var _t = $(this);
          if ($(window).width() < 992) {
            _t.toggleClass('active');
            _t.siblings('.filter__content').slideToggle(300);
          }
          return false;
        });
      }

      if ($('.js-faq-toggle').length) {
        $('.js-faq-toggle').on('click', function() {
          var _t = $(this);
          _t.toggleClass('active');
          _t.siblings('.faq__item-content').slideToggle(300);
          return false;
        });
      }

      if ($('.js-toggle-sublist').length) {
        $('.js-toggle-sublist').on('click', function() {
          var _t = $(this);
          _t.toggleClass('active');
          _t.siblings('.aside-nav__sublist').slideToggle(300);
          return false;
        });
      }

      if ($('.js-tabs-btn').length) {
        $('.js-tabs-btn').on('click', function() {
          var _t = $(this),
            _tData = _t.data('tabs-nav'),
            _tTabs = _t.parents('.tabs').find('.tabs__list-item');
          if (_t.parents('.tabs').find('.tabs__list-item[data-tabs-item="'+_tData+'"]').length) {
            $('.js-tabs-btn').removeClass('tabs__nav-list-btn--active');
            _t.addClass('tabs__nav-list-btn--active');
            _tTabs.fadeOut(350);
            setTimeout(function() {
              _t.parents('.tabs').find('.tabs__list-item[data-tabs-item="'+_tData+'"]').fadeIn(350);
            }, 350);
          }
          return false;
        });
      }

      $(window).on('resize', function() {
        if ($('.wis-content > table').length) {
          $('.wis-content > table').wrap("<div class='table-wrap'></div>");
        }
      });

      $(window).trigger('scroll').trigger('resize');

      return this;
    }

  }.init();

});
